import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 19V13.5C21 13.3674 20.9473 13.2402 20.8536 13.1464C20.7598 13.0527 20.6326 13 20.5 13H19.5C19.3674 13 19.2402 13.0527 19.1464 13.1464C19.0527 13.2402 19 13.3674 19 13.5V19H5V5H10.5C10.6326 5 10.7598 4.94732 10.8536 4.85355C10.9473 4.75979 11 4.63261 11 4.5V3.5C11 3.36739 10.9473 3.24021 10.8536 3.14645C10.7598 3.05268 10.6326 3 10.5 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19ZM20.51 3.23L20.78 3.5V3.49C20.9159 3.62558 20.9946 3.80811 21 4V10.5C21 10.6326 20.9473 10.7598 20.8536 10.8536C20.7598 10.9473 20.6326 11 20.5 11H19.5C19.3674 11 19.2402 10.9473 19.1464 10.8536C19.0527 10.7598 19 10.6326 19 10.5V6.42L10.56 14.85C10.5135 14.8969 10.4582 14.9341 10.3973 14.9594C10.3364 14.9848 10.271 14.9979 10.205 14.9979C10.139 14.9979 10.0736 14.9848 10.0127 14.9594C9.95178 14.9341 9.89648 14.8969 9.85 14.85L9.15 14.15C9.10314 14.1035 9.06594 14.0482 9.04055 13.9873C9.01517 13.9264 9.0021 13.861 9.0021 13.795C9.0021 13.729 9.01517 13.6636 9.04055 13.6027C9.06594 13.5418 9.10314 13.4865 9.15 13.44L17.59 5H13.5C13.3674 5 13.2402 4.94732 13.1464 4.85355C13.0527 4.75979 13 4.63261 13 4.5V3.5C13 3.36739 13.0527 3.24021 13.1464 3.14645C13.2402 3.05268 13.3674 3 13.5 3H20C20.1933 3.00802 20.376 3.09042 20.51 3.23Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgOpenInNew1Outline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgOpenInNew1Outline;
